import { PositionedUI } from './PositionedUI';

export class LabelUI extends PositionedUI {
  constructor(hud, layer, position, text, anchor) {
    super(hud, layer, position, createLabelHost(text), anchor);

    this.labelHost = this.innerDom.firstChild;
    this.textHost = this.labelHost.firstChild;
    this.text = text;
  }

  setText(text) {
    if (this.text === text) return;

    this.text = text;
    this.textHost.textContent = text;
    this.updateDimensionsOnNextFrame();
  }
}

const createLabelHost = (label) => {
  return [
  '<div>',
  `<span>${label}</span>`,
  '</div>'].
  join("");
};